import { render, staticRenderFns } from "./newIindex.vue?vue&type=template&id=fb0625a8&scoped=true&"
import script from "./newIindex.vue?vue&type=script&lang=js&"
export * from "./newIindex.vue?vue&type=script&lang=js&"
import style0 from "./newIindex.vue?vue&type=style&index=0&id=fb0625a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0625a8",
  null
  
)

export default component.exports